/* ===== CATI Pakistan — Dynamic User Theme Switcher ===== */

const THEMES = [
  { id: 'classic', name: 'CATI Classic Navy' },
  { id: 'cyber-neon', name: 'Cyber Aviation Neon (Dark)' },
  { id: 'luxury-gold', name: 'Executive Slate & Gold' },
  { id: 'emerald-horizon', name: 'Emerald Aviation' }
];

const THEME_STORAGE_KEY = 'cati_user_theme';

export function initThemeSwitcher() {
  // 1. Read stored theme preference (Local Client Machine Only)
  const savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
  if (savedTheme && savedTheme !== 'classic') {
    document.documentElement.setAttribute('data-user-theme', savedTheme);
  }

  // 2. Attach click handlers to any theme button
  const themeBtns = document.querySelectorAll('.top-bar__theme-btn, #btnChangeTheme');
  if (themeBtns.length === 0) return;

  // Update button active state if non-classic theme is active
  updateButtonVisuals(savedTheme || 'classic', themeBtns);

  themeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const currentTheme = document.documentElement.getAttribute('data-user-theme') || 'classic';
      const currentIndex = THEMES.findIndex(t => t.id === currentTheme);
      const nextIndex = (currentIndex + 1) % THEMES.length;
      const nextTheme = THEMES[nextIndex];

      // Save to client's browser local storage
      if (nextTheme.id === 'classic') {
        localStorage.removeItem(THEME_STORAGE_KEY);
        document.documentElement.removeAttribute('data-user-theme');
      } else {
        localStorage.setItem(THEME_STORAGE_KEY, nextTheme.id);
        document.documentElement.setAttribute('data-user-theme', nextTheme.id);
      }

      updateButtonVisuals(nextTheme.id, themeBtns);
      showThemeToast(`Theme Switched: ${nextTheme.name}`);
    });
  });
}

function updateButtonVisuals(activeThemeId, btns) {
  btns.forEach(btn => {
    if (activeThemeId && activeThemeId !== 'classic') {
      btn.classList.add('active-glow');
    } else {
      btn.classList.remove('active-glow');
    }
  });
}

function showThemeToast(msg) {
  let toast = document.getElementById('cati-theme-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'cati-theme-toast';
    toast.style.cssText = `
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 9999;
      background: var(--clr-secondary);
      color: var(--clr-text-on-dark);
      padding: 12px 20px;
      border-radius: 8px;
      box-shadow: 0 10px 25px rgba(0,0,0,0.3);
      border: 1px solid var(--clr-accent);
      font-weight: 600;
      font-size: 0.9rem;
      display: flex;
      align-items: center;
      gap: 10px;
      transition: all 0.3s ease;
      opacity: 0;
      transform: translateY(20px);
    `;
    document.body.appendChild(toast);
  }

  toast.innerHTML = `<i class="fa-solid fa-palette" style="color:var(--clr-accent)"></i> ${msg}`;
  toast.style.opacity = '1';
  toast.style.transform = 'translateY(0)';

  clearTimeout(window._themeToastTimer);
  window._themeToastTimer = setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(20px)';
  }, 2500);
}
